import Reflux from 'reflux';

export var Actions = Reflux.createActions([
  'loadingState',
  'alertOpen',
  'alertClose',
  'doCheckValidation',
  'doExperience',
  'doInquiry',
  'doMovePage',
  'doEventPopClose',
  'goBack'
]);